import { LoadingButton } from '@mui/lab'
import { styled } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

export const CustomContainedButton = styled(LoadingButton)(() => {
  return {
    height: '3.25rem',
    fontSize: '14px',
    padding: '14px 28px',
    borderRadius: '26px',
    textTransform: 'none',
    ":disabled": {
      color: '#fff',
      background: '#B3BBC6'
    }
  }
})

export const CustomSmallContainedButton = styled(LoadingButton)(() => {
  const matches = useMediaQuery('(min-width:750px)')
  return {
    width: matches ? '' : '100%',
    color: '#fff',
    height: '40px',
    fontSize: '14px',
    padding: '16px',
    borderRadius: '26px',
    textTransform: 'none',
  }
})

export const CustomOutlinedButton = styled(LoadingButton)(() => {
  const matches = useMediaQuery('(min-width:750px)')
  return {
    width: matches ? '' : '100%',
    height: '3.25rem',
    fontSize: '14px',
    padding: '14px 28px',
    borderRadius: '26px',
    textTransform: 'none',
  }
})

export const CustomSmallOutButton = styled(LoadingButton)(() => {
  const matches = useMediaQuery('(min-width:750px)')
  return {
    width: matches ? '' : '100%',
    border: 'none !important',
    height: '40px',
    fontSize: '14px',
    padding: '16px',
    borderRadius: '26px',
    textTransform: 'none',
    background: '#fff',
  }
})

export const CustomSmallOutlinedButton = styled(LoadingButton)(() => {
  const matches = useMediaQuery('(min-width:750px)')
  return {
    width: matches ? '' : '100%',
    height: '40px',
    fontSize: '14px',
    padding: '16px',
    borderRadius: '26px',
    textTransform: 'none',
    background: '#fff',
  }
})
